import styled from 'styled-components';
import AutoExpandTextarea from '../AutoExpandTextarea';

export const TitleInputContainer = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  button {
    background: transparent;
    border: none;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.gray5};
  }
`;

export const TitleInputStyled = styled(AutoExpandTextarea)`
  min-width: 100px;
  max-width: ${({ maxWidth }) => maxWidth ?? 600}px;
  font-size: ${({ fontSize }) => fontSize ?? 22}px;
  line-height: 1.5;
  font-weight: 500;
  letter-spacing: -0.3px;
  white-space: nowrap;
  flex-grow: 1;
  && {
    border-radius: 2px;
  }
`;
